//libs
import React,{Component} from "react";
import {connect} from "react-redux";
import axios from 'axios';
//other
import {setTrue} from "../../../actions/refresh";
import {post as createStation, put as updateStation, getGroupTypes} from "../../../actions/stations";
import {post as createWheelChanger, put as updateWheelChanger} from "../../../actions/wheelChangers";
import Config from "../../../config";
import {notification,isAdmin} from "../../../helpers";
import TextField from "./Form_Elements/TextField";
import PopUp from "./PopUp";

class UpdateOrderLimit extends Component {

    constructor(props) {
        super(props);

        this.state = {
            orderLimit: 0,
            showConfirmation: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.getOrderLimit = this.getOrderLimit.bind(this)
    }

    componentDidMount() {
        this.getOrderLimit()
    }

    confirmAction(){
        this.setState({
            showConfirmation:true
        });
    }

    handleConfirm(){
        this.setState({
            showConfirmation:false
        });
        this.handleUpdateOrderLimit()
    }

    handleCancel(){
        this.setState({
            showConfirmation:false
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.confirmAction();
    }

    handleChange(e,id) {
        let currentState = this.state;
        currentState[id] = e.target.value;

        this.setState(currentState);
    }

    getOrderLimit() {

        if (!isAdmin()){
            return false;
        }

        let requestUrl = Config.api.getDomain() + 'admin/setting';

        this.setState({sending: true}, () => {
            axios.get(requestUrl, Config.api.getConfig())
                .then(response => {
                    this.setState({
                        sending: false,
                        orderLimit: response.data.orderLimit
                    })
                })
                .catch(error => {
                    console.log(error);
                    console.log('Fel: Går ej att hitta order kapacitet')
                })
        })
    }

    handleUpdateOrderLimit() {
        if (!isAdmin()){
            return false;
        }

        const data = {
            orderLimit: this.state.orderLimit
        }

        let requestUrl = Config.api.getDomain() + 'admin/setting';

        this.setState({sending: true}, () => {
            axios.patch(requestUrl, data, Config.api.getConfig())
                .then(response => {
                    this.setState({
                        sending: false,
                        orderLimit: response.data.orderLimit
                    })
                    notification("Order kapacitet sparades!");
                })
                .catch(error => {
                    console.log(error);
                    console.log('Fel: Går ej att uppdatera order kapacitet')
                    notification("Order kapacitet sparades inte!");
                })
        })
    }

    handleDateChangeRaw(e){
        e.preventDefault()
    }

    render() {

        if (!isAdmin()){
            return null;
        }

        let buttonTitle="Updatera";
        let title="Uppdatera order kapacitet";

        let orderLimit = (
            <TextField
                title={"Max antal ordrar"}
                name='orderLimit'
                id='updateOrderLimit'
                value={this.state.orderLimit}
                onChange={(e)=>this.handleChange(e,'orderLimit')}
            />
        );

        return (
            <div className='box edit-last-on-rent-date'>
                <div className='box-inner'>
                    <h2>{title}</h2>
                    <form onSubmit={this.handleSubmit}>

                        <div className='date'>

                            {orderLimit}

                        </div>

                        <input
                            disabled={(!this.state.orderLimit)}
                            type="submit"
                            className="submit creategroupsubmit form-submit"
                            value={buttonTitle}
                        />
                    </form>

                    {this.state.showConfirmation &&
                        <PopUp
                            title="Vill du uppdatera order kapacitet?"
                            show={true}
                            onAccept={(e)=>this.handleConfirm(e)}
                            onCancel={(e)=>this.handleCancel(e)}
                        />
                    }


                </div>
            </div>



        );
    }
}

/**
 * Map state to properties
 */
const mapStateToPropsForEditLastOnRentDate = (state) => {
    return {
        refresh: state.refresh,
        submitting: state.stations.submitting,
        groupTypes: state.stations.groupTypes,
        groups: state.stations.groups
    };
};

/**
 * Map actions to properties
 */
const mapDispatchToPropsForEditLastOnRentDate = (dispatch) => {
    return {
        setTrue: (key) => dispatch(setTrue(key)),
        createStation:(data) => dispatch(createStation(data)),
        createWheelChanger:(data) => dispatch(createWheelChanger(data)),
        getGroupTypes:()=>dispatch(getGroupTypes()),
        updateStation:(data) => dispatch(updateStation(data)),
        updateWheelChanger:(data) => dispatch(updateWheelChanger(data))
    };
};

/**
 * Create groups
 */
export default connect(mapStateToPropsForEditLastOnRentDate, mapDispatchToPropsForEditLastOnRentDate)(UpdateOrderLimit);


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/UpdateOrderLimit.js